/**
 * Created by Administrador on 24/04/2017.
 */
(function(){
    'use strict';

    angular
        .module('completeAir')
        .controller('dosageCtrl', dosageCtrl)
        .controller('newDosageCtrl', newDosageCtrl)
        .controller('editDosageCtrl', editDosageCtrl)
        .controller('deleteDosageController', deleteDosageController);

    dosageCtrl.$inject = ['dosages','linkService'];
    newDosageCtrl.$inject = ['dosageService','economicActivityService','linkService','taxpayers',
        'billingModes','dateService'];
    editDosageCtrl.$inject = ['dosageService','economicActivityService','dosage','taxpayers',
        'billingModes','linkService','isDisabled','dateService'];
    deleteDosageController.$inject = ['dosageService','$uibModalInstance', '$stateParams'];

    function dosageCtrl(dosages,linkService) {
        var vm = this;
        vm.linkService = linkService;
        vm.pages = [];
        vm.dosages = (dosages.data._embedded) ? dosages.data._embedded.dosages : [];
        vm.pages = dosages.data.page;
    }

    function newDosageCtrl(dosageService,economicActivityService,linkService,taxpayers,
                           billingModes,dateService) {
        var vm = this;
        vm.isDisabled = false;
        vm.taxpayers = taxpayers;
        vm.economicActivities = [];
        vm.billingModes = billingModes;
        vm.isEdit = false;
        vm.today = new Date();
        vm.today.setHours(0,0,0,0);

        vm.datePickerOpenStatus = {
            'deadline': false,
            'startDate': false
        };

        vm.datepickerStartDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.today
            }
        };

        vm.datepickerDeadline = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.today
            }
        };
        //vm.pickerButtons = datePickerService.pickerButtons();
        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.changeHandlerDeadLine = function (form) {
            if(form.deadline.$modelValue != undefined){
                form.deadline.$setValidity('dateHigherToday', vm.dosage.deadline.getTime() >= vm.datepickerDeadline.datepickerOptions.minDate.getTime());
            }else{
                form.deadline.$setValidity('date', false);
            }
        }

        vm.changeHandlerStartDate = function (form) {
            if(form.startDate.$modelValue != undefined){
                form.startDate.$setValidity('dateHigherToday', vm.dosage.startDate.getTime() >= vm.datepickerStartDate.datepickerOptions.minDate.getTime());
                vm.datepickerDeadline.datepickerOptions.minDate = vm.dosage.startDate;
                if(form.deadline.$modelValue != undefined){
                    if(vm.dosage.startDate.getTime() > vm.dosage.deadline.getTime()){
                        vm.dosage.deadline = '';
                    }
                }
            }else{
                form.startDate.$setValidity('date', false);
            }
        }

        vm.getEconomicActivities = function(taxpayer){
            if(taxpayer != undefined){
                economicActivityService.getEconomicActvitiesNotStateWaitingByTaxpayer(linkService.getLinkId(taxpayer._links.self.href))
                    .then(function(response){
                        vm.economicActivities = response;
                    });
            }else{
                vm.economicActivities = [];
            }
        }

        vm.saveDosage = function(isValid, dosage){
            if(isValid){
                var saveForm = {
                    "economicActivityId": parseInt(linkService.getLinkId(dosage.economicActivity._links.self.href)),
                    "billingModeId": parseInt(linkService.getLinkId(dosage.billingMode._links.self.href)),
                    "authorizationNumber": dosage.authorizationNumber,
                    "tramitNumber": dosage.tramitNumber,
                    "numberInitialInvoice": dosage.numberInitialInvoice,
                    "key": dosage.key,
                    "startDate": dosage.startDate,
                    "deadline": dosage.deadline,
                    "genericLegend": dosage.genericLegend
                }
                dosageService.saveDosage(saveForm);
            }
        }

        vm.getDosageActive = function(economicActivity){
            if(economicActivity != undefined){
                dosageService.getDosageActiveByEconomicActivity(linkService.getLinkId(economicActivity._links.self.href))
                    .then(function(response){
                        if(response == undefined){
                            var aux = new Date();
                            aux.setHours(0,0,0,0)
                            vm.datepickerDeadline.datepickerOptions.minDate = aux;
                            vm.datepickerStartDate.datepickerOptions.minDate = aux;
                        }else{
                            var aux = new Date(response.deadline);
                            vm.datepickerDeadline.datepickerOptions.minDate = (dateService.addDays(aux,1));
                            vm.datepickerStartDate.datepickerOptions.minDate = (dateService.addDays(aux,1));
                        }
                        vm.dosage.startDate = vm.datepickerStartDate.datepickerOptions.minDate;
                        vm.dosage.deadline = "";
                    });
            }else{
                var aux = new Date();
                aux.setHours(0,0,0,0)
                vm.datepickerDeadline.datepickerOptions.minDate = aux;
                vm.datepickerStartDate.datepickerOptions.minDate = aux;
                vm.dosage.startDate = aux;
                vm.dosage.deadline = "";
            }
        }
    }

    function editDosageCtrl(dosageService,economicActivityService,dosage,taxpayers,billingModes,
                            linkService,isDisabled,dateService) {
        var vm = this;
        vm.isDisabled = true;
        vm.taxpayers = taxpayers;
        vm.economicActivities = [];
        vm.billingModes = billingModes;
        vm.isDisabled = isDisabled;
        vm.dosage = {
            'taxpayer': dosage.data._embedded.taxpayer,
            'economicActivity': dosage.data._embedded.economicActivity,
            'billingMode': dosage.data._embedded.billingMode,
            "authorizationNumber": parseInt(dosage.data.authorizationNumber),
            "tramitNumber": parseInt(dosage.data.tramitNumber),
            "numberInitialInvoice": parseInt(dosage.data.numberInitialInvoice),
            "key": dosage.data.key,
            "startDate": new Date(dosage.data.startDate),
            "deadline": new Date(dosage.data.deadline),
            "genericLegend": dosage.data.genericLegend,
            "id": linkService.getLinkId(dosage.data._links.self.href)
        }
        vm.flag = false;
        vm.isEdit = true;

        vm.today = new Date();
        vm.today.setHours(0,0,0,0);

        vm.datePickerOpenStatus = {
            'deadline': false,
            'startDate': false
        };
        vm.datepickerStartDate = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.today
            }
        };

        vm.datepickerDeadline = {
            dateFormat: 'dd/MM/yyyy',
            datepickerOptions: {
                showWeeks: false,
                minDate: vm.today
            }
        };

        vm.openCalendar = function(date) {
            vm.datePickerOpenStatus[date] = true;
        };

        vm.changeHandlerDeadLine = function (form) {
            if(form.deadline.$modelValue != undefined){
                form.deadline.$setValidity('dateHigherToday', vm.dosage.deadline.getTime() >= vm.datepickerDeadline.datepickerOptions.minDate.getTime());
            }else{
                form.deadline.$setValidity('date', false);
            }
        }

        vm.changeHandlerStartDate = function (form) {
            if(form.startDate.$modelValue != undefined){
                form.startDate.$setValidity('dateHigherToday', vm.dosage.startDate.getTime() >= vm.datepickerStartDate.datepickerOptions.minDate.getTime());
                vm.datepickerDeadline.datepickerOptions.minDate = vm.dosage.startDate;
                if(vm.dosage.startDate.getTime() > vm.dosage.deadline.getTime()){
                    vm.dosage.deadline = '';
                }
            }else{
                form.startDate.$setValidity('date', false);
            }
        }

        vm.getEconomicActivities = function(taxpayer){
            if(taxpayer != undefined){
                economicActivityService.getEconomicActvitiesByTaxpayer(linkService.getLinkId(taxpayer._links.self.href))
                    .then(function(response){
                        vm.economicActivities = response;
                    });
            }else{
                vm.economicActivities = [];
            }
        }

        vm.getEconomicActivities(dosage.data._embedded.taxpayer);

        vm.saveDosage = function(isValid, dosage){
            if(isValid){
                var saveForm = {
                    "economicActivityId": parseInt(linkService.getLinkId(dosage.economicActivity._links.self.href)),
                    "billingModeId": parseInt(linkService.getLinkId(dosage.billingMode._links.self.href)),
                    "authorizationNumber": dosage.authorizationNumber,
                    "tramitNumber": dosage.tramitNumber,
                    "numberInitialInvoice": dosage.numberInitialInvoice,
                    "key": dosage.key,
                    "startDate": dosage.startDate,
                    "deadline": dosage.deadline,
                    "genericLegend": dosage.genericLegend
                }
                dosageService.updateDosage(saveForm,dosage.id);
            }
        }

        vm.getDosageActive = function(economicActivity){
            if(economicActivity != undefined){
                dosageService.getDosageActiveByEconomicActivity(linkService.getLinkId(economicActivity._links.self.href))
                    .then(function(response){
                        if(response == undefined){
                            var aux = new Date();
                            aux.setHours(0,0,0,0)
                            vm.datepickerDeadline.datepickerOptions.minDate = aux;
                            vm.datepickerStartDate.datepickerOptions.minDate = aux;
                        }else{
                            var aux = new Date(response.deadline);
                            vm.datepickerStartDate.datepickerOptions.minDate = (dateService.addDays(aux,1));
                            vm.datepickerDeadline.datepickerOptions.minDate = (dateService.addDays(aux,1));
                        }
                        if(vm.flag){
                            vm.dosage.startDate = vm.datepickerStartDate.datepickerOptions.minDate;
                            vm.dosage.deadline = "";
                        }
                        vm.flag = true;
                    });
            }else{
                var aux = new Date();
                aux.setHours(0,0,0,0)
                vm.datepickerDeadline.datepickerOptions.minDate = aux;
                vm.datepickerStartDate.datepickerOptions.minDate = aux;
                vm.dosage.startDate = aux;
                vm.dosage.deadline = "";
                vm.flag = true;
            }
        }
        if(!vm.isDisabled){
            vm.getDosageActive(vm.dosage.economicActivity)
        }
    }

    function deleteDosageController(dosageService, $uibModalInstance, $stateParams){
        var vm = this;
        vm.deleteDosage = function(){
            dosageService.deleteDosage($stateParams.id)
                .then(function(){
                    $uibModalInstance.close(true);
                })
        }

        vm.cancel = function () {
            $uibModalInstance.dismiss('cancel');
        };
    }

})();
